import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
/*Custom Files*/
import { LoginRoutingModule } from './login-routing.module';
import { UserLogoutComponent } from './userLogout/userLogout.component';
import { UserLoginComponent } from './userLogin/userLogin.component';
import { UserVerifyComponent } from './userVerify/userVerify.component';
import { TermsOfUseComponent } from './userRegister/termsofuse/termsofuse.component';
import { UserRegisterComponent } from './userRegister/userRegister.component';
import { ForgotPasswordComponent } from './userForgotPassword/userForgotPassword.component';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [UserLoginComponent, UserRegisterComponent,  UserLogoutComponent,UserVerifyComponent,TermsOfUseComponent,ForgotPasswordComponent]
})
export class LoginModule { }